// Central catalog of vehicle metadata extracted from commented ThreeAsset instances in ThreeBase
// Paths are stored as require-able strings so callers can do require(entry.url)
import { cityConfig } from './scenes';

const { blockSize, streetWidth, sidewalkWidth } = cityConfig;

export const VehicleCatalog = {
  cop: {
    id: 'cop',
    url: '../components/3d/vehicles/cars/cop_car_sedan.glb',
    glb: require('../components/3d/vehicles/cars/cop_car_sedan.glb'),
    type: 'car',
    position: [77, 0, 0],
    scale: 1,
    rotation: [0, 0, 0],
    indexRotation: [0, 0, 0],
    offsetPosition: [0, 0,0],
    anchor: 'bottom',
    startSpeed: [0, 0, 2],
    speed: 6.0,
    maxSpeed: 12.0,
    acceleration: 0.2,
    deceleration: 0.5,
    turnSpeed: 0.08,
    recklessFactor: 0.1,
    soundMovingUrl: null, // '../../media/police_siren.mp3' (commented)
    volume: 0.6,
    loop: true,
    distanceDecay: 3,
    soundSpeed: 0.8,
  },
  lambo: {
    id: 'lambo',
    url: '../components/3d/vehicles/cars/lambo.glb',
    glb: require('../components/3d/vehicles/cars/lambo.glb'),
    type: 'car',
    position: [77, 0, 0],
    scale: 1,
    rotation: [0, 0, 0],
  },

 

  cybertruck: {
    id: 'cybertruck',
    url: '../components/3d/vehicles/cars/cybertruck.glb',
    glb: require('../components/3d/vehicles/cars/cybertruck.glb'),
    type: 'car',
    position: [99, 0, -8],
    scale: [1.4,1.4,1.4],
    rotation: [0, 0, 0],
    indexRotation: [0, 0, 0],
    offsetPosition: [0, 0, 0],
    anchor: 'bottom',
    startSpeed: [-3, 0, 0],
    speed: 10.0,
    maxSpeed: 18.0,
    acceleration: 0.4,
    deceleration: 0.3,
    turnSpeed: 0.12,
    recklessFactor: 0.3,
    lanes: 2,
    laneOffsetExpr: 'cityConfig.streetWidth / 4',
    cityBoundsExpr: 'cityBounds',
    soundMovingUrl: '../../media/cybertruck.mp3',
    volume: 0.7,
    loop: true,
    distanceDecay: 2,
    soundSpeed: 0.3,
  },

  // dodge_charger: {
  //   id: 'dodge_charger',
  //   url: '../components/3d/vehicles/cars/dodge_charger.glb',
  //   glb: require('../components/3d/vehicles/cars/dodge_charger.glb'),
  //   type: 'car',
    
  // },
  camaro: {
    id: 'camaro',
    url: '../components/3d/vehicles/cars/camaro.glb',
    glb: require('../components/3d/vehicles/cars/camaro.glb'),
    indexRotation: [0, -Math.PI, 0],
    type: 'car',
  },
  // passenger_car: {
  //   id: 'passenger_car',
  //   url: '../components/3d/vehicles/cars/passenger_car.glb',
  //   glb: require('../components/3d/vehicles/cars/passenger_car.glb'),
  //   type: 'car',
  // },
  low_poly_bus: {
    id: 'low_poly_bus',
    url: '../components/3d/vehicles/cars/low_poly_bus.glb',
    glb: require('../components/3d/vehicles/cars/low_poly_bus.glb'),
    type: 'car',
    scale: 2,
  },
//   classic_muscle_car: {
//     id: 'classic_muscle_car',
//     url: '../components/3d/vehicles/cars/classic_muscle_car.glb',
//     glb: require('../components/3d/vehicles/cars/classic_muscle_car.glb'),
//     type: 'car',
//   },
  low_poly_car: {
    id: 'low_poly_car',
    url: '../components/3d/vehicles/cars/low_poly_car.glb',
    glb: require('../components/3d/vehicles/cars/low_poly_car.glb'),
    type: 'car',
  },
  ferrari_roma: {
    id: 'ferrari_roma',
    url: '../components/3d/vehicles/cars/ferrari_roma.glb',
    glb: require('../components/3d/vehicles/cars/ferrari_roma.glb'),
    type: 'car',
    scale: 1.2,
  },
  lada_2107: {
    id: 'lada_2107',
    url: '../components/3d/vehicles/cars/lada_2107.glb',
    glb: require('../components/3d/vehicles/cars/lada_2107.glb'),
    type: 'car',
    scale: 1.2,
  },

//   lambo: {
//     id: 'lambo',
//     url: '../components/3d/vehicles/lambo.glb',
//     glb: require('../components/3d/vehicles/lambo.glb'),
//     type: 'car',
//     position: [-44, 0, 0],
//     scale: [4, 4, 4],
//     rotation: [0, 0, 0],
//     indexRotation: [0, 0, 0],
//     offsetPosition: [0, 1.6, 0],
//     anchor: 'bottom',
//     startSpeed: [3, 0, 0],
//     speed: 8.0,
//     maxSpeed: 15.0,
//     acceleration: 0.3,
//     deceleration: 0.4,
//   },
};

let randomRoutes = [
    [

    ]
]

export function getRandomVehicleRoute() {

  let randomXSide = Math.random() < 0.5 ? -1 : 1;
  let randomZSide = Math.random() < 0.5 ? -1 : 1;

  let fullBlock = blockSize + streetWidth + sidewalkWidth;
    
  let startPointX = (cityConfig.blocksX * (blockSize + streetWidth + sidewalkWidth)) / 2;
  let startPointZ = (cityConfig.blocksZ * (blockSize + streetWidth + sidewalkWidth)) / 2;
  let randomRoutes = [
    [ 
        [startPointX, 0, -streetWidth/4],
        [-startPointX, 0, -streetWidth/4],
    ], [
        [-startPointX, 0, streetWidth/4],
        [startPointX, 0, streetWidth/4],
    ], [
        [startPointX-fullBlock+streetWidth/4, 0, startPointZ],
        [startPointX-fullBlock+streetWidth/4, 0, -startPointZ],
    ],
    [
        [startPointX-fullBlock-streetWidth/4, 0, -startPointZ],
        [startPointX-fullBlock-streetWidth/4, 0, startPointZ],
    ], [
        [startPointX-fullBlock*2+streetWidth/4, 0, startPointZ],
        [startPointX-fullBlock*2+streetWidth/4, 0, -startPointZ],
    ],
    [
        [startPointX-fullBlock*2-streetWidth/4, 0, -startPointZ],
        [startPointX-fullBlock*2-streetWidth/4, 0, startPointZ],
    ]
  ];
  let route = randomRoutes[Math.floor(Math.random() * randomRoutes.length)];
 
  return route;
}

export default VehicleCatalog;


